import { SELECTION_MODE_INCLUDE } from '@tanium/react-use-selection';
import { Id } from '../../types/Id';
import {
  StackedRibbonListMinimalProps,
  StackedRibbonListProps,
} from '../../types/StackedRibbonListComponentTypes';

type UseStackedRibbonListReturnType<TId extends Id, TItem> = StackedRibbonListMinimalProps<
  TId,
  TItem
>;

export const useStackedRibbonList = <TId extends Id, TItem>(
  props: StackedRibbonListProps<TId, TItem>,
): UseStackedRibbonListReturnType<TId, TItem> => {
  const {
    actions,
    actionsVerticalAlignment,
    checkboxVerticalAlignment,
    columns,
    dataGetter,
    disclosureVerticalAlignment,
    enableRowHighlight = true,
    isIdEmphasized,
    isItemLoaded,
    isLoading,
    isSelectionEnabled,
    itemCount,
    itemIdGetter,
    onSortChange,
    selectionTooltipContent,
    sort,
    totalItemCount,
    verticalAlignment,
    // selection props
    isSelectable,
    enableSelectAll = true,
    selection = new Set([]),
    selectionMode = SELECTION_MODE_INCLUDE,
    onSelectionChange,
    // expansion props
    expandableContent,
    defaultExpansion,
    defaultExpansionMode,
    expansion,
    expansionMode,
    onExpansionChange,
    hideExpansionDisclosure,
    enableExpandAll,
  } = props;

  return {
    actions,
    actionsVerticalAlignment,
    checkboxVerticalAlignment,
    columns,
    disclosureVerticalAlignment,
    dataGetter,
    enableRowHighlight,
    isIdEmphasized,
    isItemLoaded,
    isLoading,
    isSelectionEnabled,
    itemCount,
    itemIdGetter,
    onSortChange,
    selectionTooltipContent,
    sort,
    totalItemCount,
    verticalAlignment,
    // selection props
    isSelectable,
    enableSelectAll,
    selection,
    selectionMode,
    onSelectionChange,
    // expansion props
    expandableContent,
    defaultExpansion,
    defaultExpansionMode,
    expansion,
    expansionMode,
    onExpansionChange,
    hideExpansionDisclosure,
    enableExpandAll,
  };
};
